import React, { Fragment } from 'react'
import { Elements, StripeProvider } from 'react-stripe-elements';
import {
    Dialog,
    DialogContent,
    Typography,
    Paper,
    IconButton,
    withStyles,
    Fab, DialogTitle, Button,
    DialogActions
} from "@material-ui/core";
import { Close, Add } from '@material-ui/icons'
import { connect } from "react-redux";
import APIService from "../../../apis/amplify/APIService";
import {
    receive_cards,
} from "../../../apis/redux/fetchActions";
import CreditCardDialog from "../../../components/CreditCardDialog";
import { constants } from "../../../util";
import { styles } from './styles'
import { bindActionCreators } from "redux";
import { SectionRight, SectionTitle } from "../../../components/SectionTitleContainer";
import SectionTitleContainer from "../../../components/SectionTitleContainer";
import Adaptable from "../../../components/Adaptable";
import { errorBundaryHOC } from '../../../components/ErrorBoundary';
import Loading, { LoadingText, Progress } from "../../../components/Loading";
import If from "../../../components/If";
import { ERROR_TYPE, NActionButton, SUCCESS_TYPE } from "../../../components/Notification";
import Notification from "../../../components/Notification";

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedCardId: null,
            loading: false,
            loadingText: '',
            addDialogOpen: false,
            snackBarOpen: false,
            snackBarText: '',
            notify: false,
            notifyError: false,
            notifyMessage: '',
            deleteCardConfirmationOpen: false,
            pendingCardDeleteId: null,
        }
    }

    componentDidMount() {
        const { receiveCards } = this.props;
        if (!receiveCards || !receiveCards.length) {
            this.loadCreditCards();
        }
    }

    async loadCreditCards() {
        this.setState({ loading: true, loadingText: 'Loading credit cards...' });
        const { ok, data } = await APIService.getPaymentCardList();
        if (ok) {
            this.props.actions.receiveCards(data);
        }
        this.setState({ loading: false });
    }

    onDelete(id, event) {
        event.stopPropagation();
        this.setState({ deleteCardConfirmationOpen: true, pendingCardDeleteId: id });
    }

    async processDelete() {
        const { pendingCardDeleteId } = this.state;
        this.setState({ loading: true, loadingText: 'Deleting card...', deleteCardConfirmationOpen: false });
        const { ok, data } = await APIService.deletePaymentCard(pendingCardDeleteId);
        if (ok && data.deleted) {
            await this.loadCreditCards();
        } else {
            this.showNotification('An error occurred while deleting the card', true);
            this.setState({ loading: false });
        }
    }

    showAddDialog() {
        this.setState({ addDialogOpen: true })
    }

    showNotification(message, isError) {
        this.setState({ notify: true, notifyError: isError, notifyMessage: message })
    }

    onCardAdded = () => {
        this.loadCreditCards();
    };

    render() {
        const { classes, cardsList } = this.props;
        const { deleteCardConfirmationOpen, loading, notifyMessage, notifyError, notify, loadingText } = this.state;
        return (
            <div style={{ marginBottom: '50px' }}>


                <Dialog open={deleteCardConfirmationOpen} disableBackdropClick={false}
                        onBackdropClick={() => this.setState({ deleteCardConfirmationOpen: false })}>
                    <DialogTitle disableTypography>
                        <Typography variant="h6" color="primary" align="center"
                                    className={classes.dialogTitle}>
                            DELETE CARD
                        </Typography>
                    </DialogTitle>
                    <DialogContent>
                        <Typography variant="subtitle2" align="center"
                                    style={{ paddingLeft: '20px', paddingRight: '20px' }}>
                            Are you sure of delete your card?
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button fullWidth variant='contained'
                                onClick={() => this.setState({ deleteCardConfirmationOpen: false })}>
                            Cancel
                        </Button>
                        <Button fullWidth color='secondary' variant='contained'
                                onClick={this.processDelete.bind(this)}>
                            Yes
                        </Button>
                    </DialogActions>
                </Dialog>

                <StripeProvider apiKey={constants.StripeToken}>
                    <Elements>
                        <CreditCardDialog open={this.state.addDialogOpen}
                                          onBackdropClick={() => this.setState({ addDialogOpen: false })}
                                          onCardAdded={this.onCardAdded}/>
                    </Elements>
                </StripeProvider>

                <SectionTitleContainer>
                    <SectionTitle>Credit Cards</SectionTitle>
                    <Adaptable hideFromSmallDown>
                        <SectionRight onClick={this.showAddDialog.bind(this)} color='secondary' underline='hover'>
                            ADD CARD
                        </SectionRight>
                    </Adaptable>
                </SectionTitleContainer>

                <div className={classes.cardList}>
                    <If as={Loading} condition={loading} style={{ padding: '30px 0' }}>
                        <Progress/><LoadingText>{loadingText}</LoadingText>
                    </If>
                    {(!loading && !cardsList.length) ?
                        (
                            <div style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
                                <Typography className={classes.emptyTypography} style={{ marginTop: 0, paddingTop: 30 }}
                                            variant='subtitle1' align="center">
                                    Please add a credit card
                                </Typography>
                            </div>
                        )
                        :
                        (
                            <Fragment>
                                {cardsList.map(card => {
                                    return (
                                        <Paper elevation={0} key={card.id} className={classes.itemDiv}>
                                            <div style={{
                                                display: 'flex',
                                                flexGrow: 1,
                                                alignSelf: 'center',
                                                flexDirection: 'column'
                                            }}>
                                                <Typography>
                                                    ●●●● ●●●● ●●●● {card.last4}
                                                </Typography>
                                                <Typography variant='subtitle2' className={classes.brandText}>
                                                    {card.brand}
                                                </Typography>
                                            </div>
                                            <span className={classes.buttonCard}>
                                                        <IconButton onClick={this.onDelete.bind(this, card.id)}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" height="18"
                                                                 width="18"
                                                                 viewBox="0 0 18 18">
                                                                <g>
                                                                    <path id="path1"
                                                                          transform="rotate(0,9,9) translate(2.25000563263423,0) scale(0.562499530613814,0.562499530613814)  "
                                                                          fill="#000000"
                                                                          d="M15.000001,8.0000272L17,8.0000272 17,27.000028 15.000001,27.000028z M11.000001,8.0000272L13.000001,8.0000272 13.000001,27.000028 11.000001,27.000028z M7.0000005,8.0000272L9.000001,8.0000272 9.000001,27.000028 7.0000005,27.000028z M3.0790101,5.0000274L4.9959994,29.922999 19.000006,30.000026 20.918949,5.0000274z M13.771989,1.9959999L10.198989,2.0000001C10.158989,2.025,9.9989892,2.241,9.9989892,2.6000001L9.9989892,3.0000258 13.998989,3.0000258 13.998989,2.6000001C13.998989,2.241,13.838988,2.025,13.771989,1.9959999z M10.198989,0L13.798988,0C15.031989,0,15.998989,1.142,15.998989,2.6000001L15.998989,3.0000258 23.07898,3.0000258 24,3.0000272 24,5.0000274 22.925121,5.0000274 20.995976,30.076991C20.999027,31.102992,20.100956,32.000026,18.999029,32.000026L4.9990512,32.000026C3.8960255,32.000026,2.9990543,31.102992,2.999054,30.000026L1.073059,5.0000274 0,5.0000274 0,3.0000272 0.91897895,3.0000272 7.9989887,3.0000258 7.9989887,2.6000001C7.9989887,1.142,8.9659892,0,10.198989,0z"/>
                                                                </g>
                                                            </svg>
                                                        </IconButton>
                                                    </span>
                                        </Paper>
                                    )
                                })}
                            </Fragment>
                        )
                    }
                </div>

                <Notification open={notify}
                              type={notifyError ? ERROR_TYPE : SUCCESS_TYPE}
                              ActionButton={
                                  <NActionButton key="close" ariaLabel="close"
                                                 onClick={() => this.setState({ notify: false })}>
                                      <Close/>
                                  </NActionButton>}
                              onClose={() => this.setState({ notify: false })}>
                    {notifyMessage}
                </Notification>

                <Fab onClick={this.showAddDialog.bind(this)}
                     size='small' color='secondary'
                     className={classes.addDialogFabButton}>
                    <Add/>
                </Fab>

            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        cardsList: state.cardsList
    }
};

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators({
            receiveCards: receive_cards,
        }, dispatch)
    }
};

const ManageCardsStyled = withStyles(styles)(Index);
export default connect(mapStateToProps, mapDispatchToProps)(errorBundaryHOC(ManageCardsStyled));
